<div id="topInset" hidden></div>
<div id="rightInset" hidden></div>
<div id="bottomInset" hidden></div>
<div id="leftInset" hidden></div>
<app-spinner></app-spinner>
<router-outlet></router-outlet>
<div id="genesys-chat-container" *ngIf="!isApp && !hideChat">
    <app-genesys-postsignon-chat  [currentPage]="currentPage()" [selectedLob]="selectedLob()"></app-genesys-postsignon-chat>
</div>